import { render } from "./ReunioesProjetoTab.vue?vue&type=template&id=7f1a2228&scoped=true"
import script from "./ReunioesProjetoTab.vue?vue&type=script&lang=js"
export * from "./ReunioesProjetoTab.vue?vue&type=script&lang=js"

import "./ReunioesProjetoTab.vue?vue&type=style&index=0&id=7f1a2228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1a2228"]])

export default __exports__